var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"active":_vm.app.showLoader.value,"can-cancel":true}}),_c('MasterData-form'),_c('manage-MasterData-actions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }